import { splitStringValue } from '../lib/string';
import { closest } from './traverse';
import { createEvent } from '../lib/events';
/**
 * Registers a new event listener
 */
export function on(element, type, handler, options = false) {
    const elements = Array.isArray(element) ? element : [element];
    elements.forEach(element => {
        if (!element) {
            return;
        }
        splitStringValue(type).forEach(eventType => element.addEventListener(eventType, handler, options));
    });
}
/**
 * Removes the event listener for the given event
 */
export function off(element, type, handler) {
    const elements = Array.isArray(element) ? element : [element];
    elements.forEach(element => {
        if (!element) {
            return;
        }
        splitStringValue(type).forEach(eventType => element.removeEventListener(eventType, handler));
    });
}
/**
 * Registers an event listener, that is automatically removed after it was executed once.
 *
 * Returns a function to unregister the handler.
 */
export function once(element, type, handler) {
    if (!element) {
        return () => { };
    }
    const wrappedHandler = (event) => {
        handler(event);
        off(element, type, wrappedHandler);
    };
    on(element, type, wrappedHandler);
    return () => off(element, type, wrappedHandler);
}
/**
 * Registers a delegated event listener on the given element.
 * It will match any child element with the given selector.
 *
 * An event on the main element will NOT match.
 */
export function delegate(element, selector, type, handler) {
    const wrappedHandler = (event) => {
        const delegateTarget = closest(event.target, selector, element);
        if (delegateTarget) {
            handler(event, delegateTarget);
        }
    };
    return onOff(element, type, wrappedHandler);
}
/**
 * Registers an event listener on the given element and returns the function to remove it
 */
export function onOff(element, type, handler) {
    if (!element) {
        return () => { };
    }
    on(element, type, handler);
    return () => off(element, type, handler);
}
/**
 * Triggers a custom event on the given element
 */
export function trigger(element, type, data) {
    // @legacy IE 11 doesn't support the global CustomEvent
    if (!element) {
        return;
    }
    element.dispatchEvent(createEvent(type, {
        bubbles: true,
        cancelable: true,
        detail: data,
    }));
}
